import moment from "moment";
import { compact } from "lodash";
import { useLocale } from "@hooks";
import { useGetDeclaredConsultantsByCustomerQuery } from "@graphql";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow
} from "@material-ui/core";
import { ErrorCard, PlainLink, Spinner } from "@common";
import { store } from "@store";
import { CONSULTANT_SLIDER, ConsultantProfileLocation } from "@navigation";

type Props = {
  customerId: string;
};

export function DeclaredConsultants(props: Props) {
  const { locale } = useLocale();

  const { data, loading, error } = useGetDeclaredConsultantsByCustomerQuery({
    variables: {
      customerId: props.customerId
    },
    fetchPolicy: "cache-and-network"
  });

  if (loading) {
    return <Spinner />;
  }

  if (error) {
    return (
      <ErrorCard
        fullWidth
        style={{ margin: 16 }}
        title={locale.Error}
        message={error.message}
      />
    );
  }

  const onConsultantClick = (id: string) => {
    store().navigation.open(CONSULTANT_SLIDER, new ConsultantProfileLocation(id));
  };

  return (
    <TableContainer>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell width={200}>{locale.ConsultantName}</TableCell>
            <TableCell width={200}>{locale["Employment type"]}</TableCell>
            <TableCell>{locale.Competitors}</TableCell>
            <TableCell width={150}>{locale.Date}</TableCell>
          </TableRow>
        </TableHead>

        {data.consultantByWorkExperience.items.length === 0 && (
          <TableBody>
            <TableRow>
              <TableCell colSpan={4}>{locale.NoSearchResults}</TableCell>
            </TableRow>
          </TableBody>
        )}

        <TableBody>
          {data.consultantByWorkExperience.items.map((row) => {
            const empType = row.workExperience.employmentType
              ? locale.legalPersonType[row.workExperience.employmentType]
              : "";

            const from = row.workExperience.from
              ? moment(row.workExperience.from).format("MMM YYYY")
              : "";

            const to = row.workExperience.to
              ? moment(row.workExperience.to).format("MMM YYYY")
              : "";

            const date = [from, to].join("–");

            return (
              <TableRow key={row.consultant._id}>
                <TableCell component="th" scope="row">
                  <PlainLink
                    variant={"body2"}
                    onClick={() => onConsultantClick(row.consultant._id)}
                  >
                    {row.consultant.Name}
                  </PlainLink>
                </TableCell>
                <TableCell>{empType}</TableCell>
                <TableCell>
                  {compact(row.workExperience.competitors).join(", ")}
                </TableCell>
                <TableCell align="right" style={{ whiteSpace: "nowrap" }}>
                  {date}
                </TableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
